import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top whenever the pathname changes.
 * Optionally restricts to certain paths.
 */
export default function ScrollToTop({ match = "/" }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith(match)) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // or behaviour: instant for rapid change
    }
  }, [pathname, match]);

  return null;
}
